import React from "react";
import { Card, Badge, Collapse } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Utils from "../../utils";

function MobileCardGrid({ data, displayColumns, idColumn, idColumn2, selectedRunbook, onRowClick }) {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="mobile-card-grid d-md-none">
      {data.map((item, index) => {
        const isSelected = selectedRunbook &&
          selectedRunbook[idColumn] === item[idColumn] &&
          (!idColumn2 || selectedRunbook[idColumn2] === item[idColumn2]);

        // Check if this is a variable (has variableNumber) or runbook
        const isVariable = item.variableNumber !== undefined;
        const primaryText = isVariable
          ? `${item.variableNumber} - ${item.variableName}`
          : (item.runbookName || item[displayColumns[0]]);

        return (
          <Card
            key={index}
            className={`mb-3 ${isSelected ? 'border-primary' : ''}`}
            style={{ cursor: 'pointer' }}
            onClick={() => onRowClick(item)}
          >
            <Card.Body>
              {/* Always visible: Name and Category */}
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div className="flex-grow-1">
                  <h6 className="mb-1 text-primary fw-bold">
                    {primaryText}
                  </h6>
                  {item.category && (
                    <div className="mb-2">{item.category}</div>
                  )}
                </div>
                <div className="ms-2">
                  {isSelected ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>

              {/* Expandable details */}
              <Collapse in={isSelected}>
                <div>
                  <hr className="my-2" />
                  {displayColumns
                    .filter(col => {
                      // Exclude fields already shown in header
                      if (isVariable) {
                        return col !== 'variableNumber' && col !== 'variableName';
                      }
                      return col !== 'runbookName' && col !== 'category';
                    })
                    .map((column) => {
                      const value = item[column];
                      if (!value || value === '-') return null;

                      return (
                        <div key={column} className="mb-2">
                          <small className="text-muted d-block">
                            {Utils.fixCamelCase(column)}
                          </small>
                          <div>{value}</div>
                        </div>
                      );
                    })}
                </div>
              </Collapse>
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}

export default MobileCardGrid;
